/* eslint-disable max-lines-per-function */
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AccountCircle from '@material-ui/icons/AccountCircle';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link as RouterLink} from 'react-router-dom';
import locale from '../locale/Localization';
import {logoutUser} from '../store/appActions';
import {NAV_SELECT_PROFILE} from '../utils/constants';

/**
 * Map the properties.
 * @param {*} dispatch
 * @return {Function} the add user function.
 */
function mapDispatchToProps(dispatch) {
  return {
    logoutUser: () => dispatch(logoutUser())
  };
}

/**
 * ConnectedAuth component for authentication logic.
 * @param {Object}  event the event object.
 */
class ConnectedUserMenu extends Component {
  // eslint-disable-next-line require-jsdoc
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      open: false
    };
  }

  handleLogout = async () => {
    await this.props.logoutUser();
    window.location.href = '/logout';
  };

  handleMenu = (event) => {
    this.setState({anchorEl: event.currentTarget, open: true});
  };

  handleClose = () => {
    this.setState({anchorEl: null, open: false});
  };

  // Handles the page select within the profile menu.
  handleOnClick = (nav: string) => {
    this.props.onClick(nav);
    this.handleClose();
  };

  /**
   * React render function.
   * @return {string} the component contents.
   */
  render() {
    return (
      <React.Fragment>
        <IconButton
          aria-label='account of current user'
          aria-controls='menu-appbar'
          aria-haspopup='true'
          onClick={this.handleMenu}
          style={{color: this.props.color}}
        >
          <AccountCircle />
        </IconButton>
        <Menu
          id='menu-appbar'
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={this.state.open}
          onClose={this.handleClose}
        >
          {this.props.showProfile && (
            <MenuItem
              component={RouterLink}
              to={NAV_SELECT_PROFILE}
              onClick={() => {
                this.handleOnClick(NAV_SELECT_PROFILE);
              }}
            >
              {locale.userProfile}
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              this.handleLogout();
            }}
          >
            {locale.logout}
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

ConnectedUserMenu.propTypes = {
  color: PropTypes.string.isRequired,
  logoutUser: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  showProfile: PropTypes.bool
};

const UserMenu = connect(null, mapDispatchToProps)(ConnectedUserMenu);
export default UserMenu;
